import React, { useState } from "react";
import { GetKey } from "../../Actions/GetContainer";
import request from "../../../../Helpers/API";
import { GetMonthNameByNumber } from "../../Helper/GetMonthNameByNumber";
import { useBox } from "../../Helper/useBox";
import { BoxFiltrosSF } from "../../Helper/BoxFiltrosSF";
import { LoaderScreen } from "../../../components/LoaderScreen";
import { Nivel1Screen } from "./Nivel1Screen";
import { useEffect } from "react";
import Swal from "sweetalert2";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHistory } from "react-router-dom";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { BoxFiltrosSF2 } from "../../Helper/BoxFiltrosSF2";
// import { DashFinancieroContext } from "../../Dashboard/DashFinancieroMain";

export const BalanceGeneralScreen = () => {
    const history = useHistory();
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [boxstate, setBoxState] = useBox();
    const storedState = JSON.parse(localStorage.getItem('dashboard_filtro')) || {};
    // console.log(boxstate)
    const [titulo, setTitulo] = useState('BALANCE GENERAL');
    const [data, setData] = useState([]);
    const [info, setInfo] = useState({});
    const BoxClick = () => {
        setLoader({ ...loader, mostrar: true });
        return new Promise((res, req) => {
            const post = {
                ejercicio: boxstate.ejercicioinicio,
                periodo: boxstate.periodoinicio,
                adr: GetKey(boxstate.pv.adr, ["idadr"]),
                sucursales: GetKey(boxstate.pv.sucursal, ["idsucursal"]),
            };

            request
                .post("FBalanceGeneral/BalanceGeneral", post)
                .then((result) => {
                    setData(result.balance);
                    setInfo(result.infobalanza);
                    setTitulo(`BALANCE GENERAL ${GetMonthNameByNumber(boxstate.periodoinicio).toUpperCase()} ${boxstate.ejercicioinicio}`);
                    setLoader({ ...loader, mostrar: false });
                    res();
                })
                .catch((err) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("Error", "Hubo un problema al cargar los datos.", "error");
                    req(JSON.stringify(err));
                });
        });
    };

    const onHome = () => {
        history.push("/Finanzas/Main")
    };

    useEffect(() => {
        const fechaActual = new Date();
        const ejercicioActual = fechaActual.getFullYear();
        const mesActual = fechaActual.getMonth() + 1;
        boxstate.ejercicioinicio = storedState.ejercicio || ejercicioActual
        boxstate.periodoinicio = storedState.periodofin || mesActual
        BoxClick();
    }, []);

    const imprimirConsolidado = () => {
        setLoader({ ...loader, mostrar: true });
        if (boxstate.ejercicioinicio === "0") {
            //   changeloading("Favor de agregar el ejercicio de inicio", true);
            return;
        }
        if (boxstate.mesInicio === "0") {
            //   changeloading("Favor de agregar el periodo de inicio", true);
            return;
        }
        const post = {
            ejercicio: Number(boxstate.ejercicioinicio),
            periodo: Number(boxstate.periodoinicio),
            adr: GetKey(boxstate.pv.adr, ["idadr"]),
            sucursales: GetKey(boxstate.pv.sucursal, ["idsucursal"]),
        };
        request
            .post("FBalanceGeneral/BalanceGeneralConsolidadoExcel", post)
            .then(({ documento, filename }) => {
                const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${filename}.xlsx`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                setLoader({ ...loader, mostrar: false });
            })
            .catch((err) => {
                // changeloading(JSON.stringify(err), true);
            });
    };
    const imprimir = () => {
        setLoader({ ...loader, mostrar: true });
        if (boxstate.ejercicioinicio === "0") {
            //   changeloading("Favor de agregar el ejercicio de inicio", true);
            return;
        }
        if (boxstate.mesInicio === "0") {
            //   changeloading("Favor de agregar el periodo de inicio", true);
            return;
        }
        const post = {
            ejercicio: Number(boxstate.ejercicioinicio),
            periodo: Number(boxstate.periodoinicio),
            adr: GetKey(boxstate.pv.adr, ["idadr"]),
            sucursales: GetKey(boxstate.pv.sucursal, ["idsucursal"]),
        };
        request
            .post("FBalanceGeneral/ExcelBalanceGeneral", post)
            .then(({ documento, filename }) => {
                const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${filename}.xlsx`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                setLoader({ ...loader, mostrar: false });
            })
            .catch((err) => {
                setLoader({ ...loader, mostrar: false });
                console.log(err);
                // changeloading(JSON.stringify(err), true);
            });
    };

    const PDFDownloadButton = () => {
        setLoader({ ...loader, mostrar: true });
        if (boxstate.ejercicioinicio === "0") {
            //   changeloading("Favor de agregar el ejercicio de inicio", true);
            return;
        }
        if (boxstate.mesInicio === "0") {
            //   changeloading("Favor de agregar el periodo de inicio", true);
            return;
        }
        const post = {
            ejercicio: Number(boxstate.ejercicioinicio),
            periodo: Number(boxstate.periodoinicio),
            adr: GetKey(boxstate.pv.adr, ["idadr"]),
            sucursales: GetKey(boxstate.pv.sucursal, ["idsucursal"]),
        };
        request
            .post("FBalanceGeneral/BalanceGeneralPDF", post)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = `data:application/pdf;base64, ${result.documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${result.nombredocumento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("Clientes", JSON.stringify(error), "error");
            });
    };

    const nombreMes = GetMonthNameByNumber(boxstate.periodoinicio);
    return (
        <PlantillaScreen
            titulo={titulo}
            className={"balance-general-main-screen"}
            className_main={1}
        >
            <LoaderScreen loader={loader} />
            <div className="balance-general-contenedor-filtros">
                <div className='balance-general-regresar'
                    onClick={() => onHome()}
                >
                    <ArrowBackIcon /> Regresar
                </div>

                <BoxFiltrosSF2
                    boxState={boxstate}
                    onBoxChange={setBoxState}
                    BoxClick={BoxClick}
                    titulo="Balance General"
                    subtitulo={`Balance General ${nombreMes} ${boxstate.ejercicioinicio}`}
                    mostrardepartamento={false}
                    mostraradr={false}
                    mostrarsucursal={false}
                    titulo_filtro="FILTRO"
                >
                </BoxFiltrosSF2>
            </div>
            <div className="box-actions">
                {/* {`${GetMonthNameByNumber(titulo.mesinicio)} ${titulo.ejercicio}. `} */}
                <button
                    className="excel"
                    onClick={imprimirConsolidado}
                >
                    <div>Balance Promedio</div>
                </button>
                <button className="PDF" onClick={imprimir}>
                    <div>Balance Mensual</div>
                </button>
                <button className="PDF" onClick={PDFDownloadButton}>
                    <div>PDF</div>
                </button>
            </div>
            <div id="balancegeneral-conainer">
                <div
                    style={{
                        width: "99%",
                        textTransform: "uppercase",
                        fontSize: 12,
                        textAlign: "right",
                        paddingRight: "10px!important",
                    }}
                >
                </div>
                <div className="info scroll-4">
                    <table cellSpacing={0} id="tabla-fixed-blank">
                        <tbody>
                            <tr className="thead">
                                {/* <td className='col-1 col-sticky'></td> */}
                                <td className="col-sticky col-2"></td>
                                <td className="col-sticky col-3"></td>
                                <td className="col-sticky col-4"></td>
                                <td className="col-sticky col-5">
                                    {GetMonthNameByNumber(boxstate.periodoinicio)} {boxstate.ejercicioinicio}
                                </td>
                                <td className="col-sticky col-6">
                                    <div> % </div>
                                </td>
                                <td className="col-sticky col-7">
                                    <div>
                                        {GetMonthNameByNumber(boxstate.periodoinicio)}{" "}
                                        {boxstate.ejercicioinicio - 1}
                                    </div>
                                </td>
                                <td className="col-sticky col-8">
                                    <div> % </div>
                                </td>
                                <td className="col-sticky col-9">
                                    <div> Variación </div>
                                </td>
                                <td className="col-sticky col-10">
                                    <div> % </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="tr-espacion-5"></td>
                            </tr>
                            <Nivel1Screen data={data} />
                        </tbody>
                    </table>
                </div>
            </div>
            {/* {JSON.stringify(data)} */}
        </PlantillaScreen >
    );
};
